"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var Tab = function (_a) {
    var tab = _a.tab, onClickHandler = _a.onClickHandler, isActiveTab = _a.isActiveTab;
    var t = (0, next_intl_1.useTranslations)('lottery');
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tabItem, " ").concat(styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[tab.slug], " ").concat(isActiveTab ? styles_module_scss_1.default.active : ''), onClick: onClickHandler },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.tabText }, t("".concat(tab.slug)))));
};
exports.default = Tab;
